import $ from 'jquery';
// Set jQuery global
window.$ = window.jQuery = $;
import './IsTouchDevice';
import 'popper.js';
import 'bootstrap';
import 'jquery.mmenu';
import 'slick-carousel';
import 'picturefill';
import 'lazysizes';
import '../../../components/sections/header-new/header-new'
//import 'jquery-unveil';

// IE11 ObjectFit
//import objectFitImages from 'object-fit-images';
//objectFitImages();

$(function () {
    var isIE = window.ActiveXObject || "ActiveXObject" in window;
    if (isIE) {
        $('.modal').removeClass('fade');
    }
});